import { View } from 'react-native';
import { isNotNil } from '../../utils';
import type { KeyboardAvoidingProps } from './KeyboardAvoiding';

/**
 * web 은 키보드 회피를 하지 않는다(no-op).
 *
 * 모바일 브라우저는 키보드가 뜨면 뷰포트 자체가 줄어들어, 하단 고정 UI(바텀시트)가 이미
 * 키보드 위에 놓인다. 여기에 RN Web `KeyboardAvoidingView` 를 씌우면 키보드 높이만큼
 * 하단 패딩을 **한 번 더** 넣어(behavior 를 주지 않아도 동작한다) 시트 안쪽 버튼 아래에
 * 죽은 여백이 생긴다.
 *
 * flex / height 만 그대로 반영하고(레이아웃 계약 유지), 회피 동작은 빼는 것이 맞다.
 */
export const KeyboardAvoiding = ({
  children,
  flex,
  height,
}: KeyboardAvoidingProps) => {
  if (isNotNil(flex) || isNotNil(height)) {
    return <View style={{ flex, height }}>{children}</View>;
  }
  return children;
};
